<div (click)="doClose($event)" [class.tvui-dialog--visible]="visible()" class="tvui-dialog">
	<div class="tvui-dialog__container">
		<ng-content></ng-content>
	</div>
</div>
